import { render, staticRenderFns } from "./CategorizationSummary.vue?vue&type=template&id=19526cd2&"
import script from "./CategorizationSummary.vue?vue&type=script&lang=ts&"
export * from "./CategorizationSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports